// extracted by mini-css-extract-plugin
module.exports = {"Travelclub":"travelclub_Travelclub__vt4QG","service":"travelclub_service__U6Yre","txt":"travelclub_txt__lkQ3A","info":"travelclub_info__Amzoy"};